module.exports = __webpack_public_path__ + "img/arrow-repeat.14648483.svg";